import type { DirectChannel, GroupDirect, PublicUser } from "@shared/api";

export const isGroup = (direct: DirectChannel): direct is GroupDirect => direct.channel_type === "group";

const nameOf = (user: PublicUser) => user.display_name || user.username;

/**
 * Как назвать переписку: пару — по собеседнику, группу — по названию, а без него
 * по участникам, как в Discord («Аня, Марат, Ильдар»).
 */
export function directName(direct: DirectChannel): string {
  if (!isGroup(direct)) return nameOf(direct.recipient);
  if (direct.name) return direct.name;
  if (direct.recipients.length === 0) return "Пустая группа";

  const names = direct.recipients.slice(0, 3).map(nameOf).join(", ");
  const more = direct.recipients.length - 3;
  return more > 0 ? `${names} и ещё ${more}` : names;
}
